import React, { StrictMode,Suspense } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthContext } from './context/auth';
import { useWallet } from './hooks/wallet';
// import { Routers } from './routers';
import { HashRouter } from "react-router-dom";
import './index.css';
import App from "./App";
import Spinner from "./screen/Spinner/Spinner";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/zh-cn';
import { LicenseInfo } from '@mui/x-license-pro';
LicenseInfo.setLicenseKey('9df6c4cf5f5d800272bec85da2ddeb46Tz03NjMxNyxFPTE3Mjg1NDQ4NDQwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y');

const queryClient = new QueryClient()
const root = createRoot(document.getElementById("root"));

const AuthProvider = ({ children }) => {
  const wallet = useWallet();

  return (
    <AuthContext.Provider value={wallet}>
      {children}
    </AuthContext.Provider>
  )
}

root.render(
  <StrictMode>
    <Suspense fallback={<Spinner />}>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="zh-cn">
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <HashRouter>
            <App/>
        </HashRouter>
      </AuthProvider>
    </QueryClientProvider>
    </LocalizationProvider>
    </Suspense>
  </StrictMode>
);
